function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@material-ui/core';
import { basePropTypes, handleProps, StyledButton } from './utils';
const BaseButton = props => {
  const {
    loading,
    disable,
    children,
    text,
    to,
    href,
    visible,
    download,
    ...rest
  } = props;
  if (visible === false) {
    return null;
  }
  const content = /*#__PURE__*/React.createElement(StyledButton, _extends({
    disabled: disable || loading
  }, handleProps(rest)), children || text, loading && /*#__PURE__*/React.createElement(CircularProgress, {
    size: 14
  }));
  if (to) {
    return /*#__PURE__*/React.createElement(Link, {
      to: to
    }, content);
  }
  if (download && href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href,
      download: download
    }, content);
  }
  if (href) {
    return /*#__PURE__*/React.createElement("a", {
      href: href
    }, content);
  }
  return content;
};
BaseButton.propTypes = basePropTypes;
export default BaseButton;